import * as angular from 'angular';
import { config } from 'angular/utils/config';

export interface StoragePremiumServiceSubscriptionResource extends ng.resource
    .IResourceClass<ng.resource.IResource<any>> {
    getPackages: ng.resource.IResourceMethod<
        ng.resource.IResource<StoragePremiumServiceSubscriptionPackageDto[]>
    >;
}

function storagePremiumServiceSubscriptionResource(
    $resource: ng.resource.IResourceService
): StoragePremiumServiceSubscriptionResource {
    return <StoragePremiumServiceSubscriptionResource>$resource(
        config.monolithApi + '/storage-premium-service-subscriptions/:id',
        { id: '@id' },
        {
            getPackages: {
                url:
                    config.monolithApi +
                    '/storage-premium-service-subscriptions/packages',
                method: 'GET',
                isArray: true
            }
        }
    );
}

angular
    .module('app')
    .factory(
        'storagePremiumServiceSubscriptionResource',
        storagePremiumServiceSubscriptionResource
    );
